export default function About() {
  return (
    <section id="about" className="relative min-h-screen bg-gradient-to-b from-[#2C1810] to-[#1A0F08] py-32">
      <div className="max-w-7xl mx-auto px-8">
        <div className="inline-block bg-purple-200/30 rounded-full px-6 py-2 mb-16">
          <span className="text-sm text-purple-100">/ Our Mission</span>
        </div>

        <div className="mb-32">
          <h2 className="text-6xl font-bold text-white mb-12 max-w-3xl leading-tight font-serif">
            Building Trust Through Innovation
          </h2>
          
          <div className="max-w-3xl space-y-6 text-lg text-[#E8DDD0] leading-relaxed">
            <p>
              At BLUE SKY SH.P.K., we are dedicated to creating exceptional iOS applications that prioritize user security and device performance. Our team of experts combines technical excellence with user-centric design principles to deliver products that make a real difference.
            </p>
            <p className="opacity-85">
              We believe that mobile security should be accessible to everyone without compromising on quality or ease of use. Our VPN and Cleaner applications are built on this foundation, offering enterprise-grade protection with consumer-friendly interfaces.
            </p>
            <p className="opacity-85">
              Every line of code we write, every feature we implement, and every update we release is guided by our commitment to excellence and our users' trust. We don't just build apps; we build relationships based on reliability and innovation.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-20">
          <div className="w-2/5">
            <div className="aspect-square rounded-3xl overflow-hidden bg-gradient-to-br from-gray-700 to-gray-900">
              <img 
                src="https://public.readdy.ai/ai/img_res/17dbf1a3200be4a93e2771ee8144a19e.jpg"
                alt="Technology visualization"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1">
            <div className="text-[120px] font-bold text-white leading-none mb-4">
              2019
            </div>
            <div className="text-2xl text-[#E8DDD0] mb-3">
              Years of Excellence
            </div>
            <p className="text-lg text-[#E8DDD0]/70 mb-12">
              Trusted by thousands of users worldwide
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
